import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
} from '@mui/x-data-grid-pro';
import { GridToolbarLayoutsButton } from '@price-for-profit/data-grid';
import { UserInfo } from 'shared/types';
import { GridToolbarAcceptProducts } from './grid-toolbar-accept-products';
import { GridToolbarMassActionButton } from './grid-toolbar-mass-action-button';

interface ProductsTableToolbarProps {
  user: UserInfo;
}
const localStorageName = 'insight.wps.product-table-configurations';

export function ProductsTableToolbar({ user }: ProductsTableToolbarProps) {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarLayoutsButton localStorageName={localStorageName} />
      <GridToolbarExport />
      <GridToolbarMassActionButton />
      <GridToolbarAcceptProducts user={user} />
    </GridToolbarContainer>
  );
}
